import { product as buildProductStructuredData } from '@forge42/seo-tools/structured-data/product';

type SeoOptions = {
  title?: string;
  description?: string;
  image?: string;
  type?: string;
  robots?: string;
  url?: string;
  siteName?: string;
  twitter?: {
    card?: string;
  };
  keywords?: string;
};

export type ProductSeoStructuredOptions = {
  name: string;
  description: string;
  images?: string[];
  brand?: string;
  url?: string;
  sku?: string;
  currency?: string;
  price?: number;
  availability?: "InStock" | "OutOfStock" | "PreOrder";
  category?: string;
};

// SEO cho sản phẩm (tách biệt với SEO từ CMS)
export function buildProductSeoMeta(opts: SeoOptions) {
  const title = `${opts.title ? `${opts.title} | ` : ""}Kland`;
  const description =
    opts.description ??
    "Kland Kết nối công nghệ kiến tạo tương lai";
  const image = opts.image ?? "/image/landing_page/Banner_1.png";
  const type = opts.type ?? "website";
  const robots =
    opts.robots ??
    "follow, index , max-snippet:-1, max-video-preview:-1, max-image-preview:large";
  const url = opts.url ?? "";
  const siteName = opts.siteName ?? "Kland";
  const twitterCard = opts.twitter?.card ?? "summary_large_image";

  const metaEntries = [
    { title },
    description ? { name: "description", content: description } : null,
    robots ? { name: "robots", content: robots } : null,
    type ? { property: "og:type", content: type } : null,
    title ? { property: "og:title", content: title } : null,
    description ? { property: "og:description", content: description } : null,
    url ? { property: "og:url", content: url } : null,
    siteName ? { property: "og:site_name", content: siteName } : null,
    image ? { property: "og:image", content: image } : null,
    twitterCard ? { name: "twitter:card", content: twitterCard } : null,
    title ? { name: "twitter:title", content: title } : null,
    description ? { name: "twitter:description", content: description } : null,
    image ? { name: "twitter:image", content: image } : null,
    opts.keywords ? { name: "keywords", content: opts.keywords } : null,
  ].filter(
    (item) => Boolean(item)
  );

  return metaEntries;
}

// Structured data cho sản phẩm (dùng @forge42/seo-tools)
export function buildProductStructured(opts: ProductSeoStructuredOptions) {
  const availabilityUrl = opts.availability
    ? `https://schema.org/${opts.availability}`
    : undefined;

  return buildProductStructuredData({
    name: opts.name,
    description: opts.description,
    image: opts.images ?? [],
    brand: opts.brand
      ? {
          "@type": "Brand",
          name: opts.brand,
        }
      : undefined,
    url: opts.url,
    sku: opts.sku,
    category: opts.category,
    offers:
      opts.price && opts.currency
        ? [
            {
              price: opts.price,
              priceCurrency: opts.currency,
              availability: availabilityUrl,
              url: opts.url,
            },
          ]
        : undefined,
  });
}
